import React, { useEffect, useRef, useState } from 'react';
import { stats } from '../mock';

function useCountUp(target, start, duration = 1500) {
  const [val, setVal] = useState(0);
  useEffect(() => {
    if (!start) return;
    const num = parseInt(String(target).replace(/[^0-9]/g, ''), 10) || 0;
    let raf;
    const t0 = performance.now();
    const step = (t) => {
      const p = Math.min((t - t0) / duration, 1);
      setVal(Math.round(num * (0.2 + 0.8 * p * (2 - p))));
      if (p < 1) raf = requestAnimationFrame(step);
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [start, target, duration]);
  const suffix = String(target).replace(/[0-9]/g, '');
  return `${val}${suffix}`;
}

function StatItem({ item }) {
  const ref = useRef(null);
  const [start, setStart] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver((entries) => {
      entries.forEach((e) => e.isIntersecting && setStart(true));
    }, { threshold: 0.4 });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);
  const v = useCountUp(item.value, start);
  return (
    <div ref={ref} className="text-center">
      <div className="text-4xl md:text-5xl font-bold text-white mb-2">{v}</div>
      <div className="text-white/75 text-sm uppercase tracking-widest">{item.label}</div>
    </div>
  );
}

export default function Stats() {
  return (
    <section className="py-20 relative overflow-hidden" style={{
      backgroundImage: `linear-gradient(rgba(15,16,32,.85), rgba(42,31,122,.85)), url(https://images.unsplash.com/photo-1494412519320-aa613dfb7738?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwzfHxjYXJnbyUyMGxvZ2lzdGljc3xlbnwwfHx8fDE3ODc0OTI0NTd8MA&ixlib=rb-4.1.0&q=85)`,
      backgroundSize: 'cover', backgroundPosition: 'center'
    }}>
      <div className="max-w-6xl mx-auto px-6 grid grid-cols-2 md:grid-cols-4 gap-10">
        {stats.map((s, i) => (<StatItem item={s} key={i} />))}
      </div>
    </section>
  );
}
